import { useEffect } from "react";
import "../../assets/coming-soon-maintenance.css";

const C = {
    zGreen: "#039606",
    zRed: "#fe0000",
    zOrange: "#ffa103",
};

const CANDLES = [
    { x: 16, high: 8, low: 92, open: 32, close: 68, up: true },
    { x: 36, high: 18, low: 88, open: 66, close: 38, up: false },
    { x: 56, high: 12, low: 84, open: 36, close: 70, up: true },
    { x: 76, high: 20, low: 80, open: 70, close: 42, up: false },
    { x: 96, high: 10, low: 76, open: 40, close: 72, up: true },
    { x: 116, high: 16, low: 82, open: 64, close: 36, up: false },
    { x: 136, high: 6, low: 74, open: 34, close: 66, up: true },
];

function Logo({ size = 120 }) {
    return (
        <img
            src="/images/luse_logo.png"
            alt="LuSE Logo"
            style={{
                width: size,
                height: "auto",
                objectFit: "contain",
            }}
        />
    );
}



function LineChartDeco() {
    return (
        <svg
            viewBox="0 0 500 70"
            preserveAspectRatio="none"
            className="line-chart"
        >
            <defs>
                <linearGradient id="lineGrad">
                    <stop offset="0%" stopColor={C.zGreen} />
                    <stop offset="100%" stopColor={C.zOrange} />
                </linearGradient>
            </defs>

            <polyline
                points="0,65 60,50 120,55 180,28 240,40 300,18 360,30 420,10 500,22"
                fill="none"
                stroke="url(#lineGrad)"
                strokeWidth={3}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeDasharray={700}
                className="chart-line"
            />
        </svg>
    );
}


export default function ComingSoon() {
    useEffect(() => {
        document.body.classList.add("luse-page");

        return () => {
            document.body.classList.remove("luse-page");
        };
    }, []);

    return (
        <div className="coming-root">

            <div className="dots"></div>

            <div className="blob green"></div>
            <div className="blob red"></div>
            <div className="blob orange"></div>

            <div className="logo-watermark">
                <Logo size={340} />
            </div>

            <LineChartDeco />

            <div className="wrapper">
                <Logo size={72} />




                <div className="name-block">
                    <div className="luse-name">
                        LuSE Academy
                    </div>

                    <div className="luse-sub">
                        Lusaka Securities Exchange
                    </div>
                </div>

                <div className="pill">
                    <span className="pill-dot"></span>
                    Coming Soon
                </div>

                <h1 className="headline">
                    Zambia's home for
                    <span className="accent">
                        market education
                    </span>
                </h1>

                <p className="tagline">
                    From your first trade to advanced market insights,
                    the LuSE Academy is being built to empower every
                    Zambian investor with the knowledge to participate
                    confidently in the capital markets.
                </p>

                <div className="divider">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>

                <p className="copyright">
                    © {new Date().getFullYear()} Lusaka Securities Exchange.
                    All rights reserved.
                </p>

            </div>

        </div>
    );
}